import { Link } from "react-router-dom";
import SVG from "../SVG";
export default function Simple({ text, svg_name, href = "" }) {
  return (
    <Link
      to={href}
      className="w-full rounded-lg border border-zi-border-light dark:border-zi-border-dark text-zi-text-light dark:text-zi-text-dark flex items-center justify-center gap-2.5 py-2 outline-none hocus-within:border-zi-border-dark hocus-within:dark:border-zi-border-light"
    >
      <SVG name={svg_name} />
      {text}
    </Link>
  );
}
